export const REQUEST = 'Admin/Prizes/REQUEST';
export const SUCCESS = 'Admin/Prizes/SUCCESS';
export const ERROR = 'Admin/Prizes/ERROR';

export const SET = 'Admin/Prizes/SET';
export const DELETED = 'Admin/Prizes/DELETED';
export const UPDATED = 'Admin/Prizes/UPDATED';
export const ADDED = 'Admin/Prizes/ADDED';